import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.pruefplan-pruefcheckliste-admin';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefplanPruefchecklisteAdminEffects {

    PruefplanPruefchecklisteAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_PRUEFPLAN_PRUEFCHECKLISTE_ADMIN),
        mergeMap((x: ac.GetPruefplanPruefchecklisteAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getPruefplanPruefchecklisteAdmin(x.pruefplan_id, x.checkliste_id).pipe(
                map((result: any) => {
                    return new ac.GetPruefplanPruefchecklisteAdminErfolgreichAction(result, x.pruefplan_id, x.checkliste_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetPruefplanPruefchecklisteAdminFehlerAction(error, x.pruefplan_id, x.checkliste_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminQueryService);
        }
        return this.service;
    }
}
